/*
  Minha História — Gerador de perguntas para pais e avós
  100% client-side. Sem chamadas externas, sem localStorage, sem cookies,
  sem dados pessoais. Toda a lógica corre no navegador.

  Modelo de cada pergunta:
    t     : texto (tratamento formal — "você" — verbo na 3.ª pessoa do singular)
    p     : compatibilidade de pessoa (tag): all | gp | par | desc | outro
            all  = pai, mãe, avô, avó, outro familiar
            gp   = avô, avó            (o utilizador é neto)
            par  = pai, mãe            (o utilizador é filho)
            desc = pai, mãe, avô, avó  (tem descendentes; exclui "outro")
    th    : tema
    tone  : leve | emocional | profundo
    sens  : 0 | 1 | 2  (2 = sensível — só aparece em "Profundo" ou "Misturado")
    alt   : (opcional) variantes gramaticais por pessoa { pai, mae, avo, ava, pais, avos, outro }
*/
(function () {
  'use strict';

  var BANK = [
    /* ───────────────────────── INFÂNCIA ───────────────────────── */
    { t: 'Qual é a primeira casa de que se lembra?', p: 'all', th: 'infancia', tone: 'leve', sens: 0 },
    { t: 'Que cheiro lhe faz pensar imediatamente na infância?', p: 'all', th: 'infancia', tone: 'emocional', sens: 0 },
    { t: 'Qual era a sua brincadeira preferida em criança?', p: 'all', th: 'infancia', tone: 'leve', sens: 0 },
    { t: 'Como era um dia normal quando era pequeno?', p: 'all', th: 'infancia', tone: 'leve', sens: 0 },
    { t: 'Que brinquedo guardava com mais carinho?', p: 'all', th: 'infancia', tone: 'emocional', sens: 0 },
    { t: 'Onde gostava de se esconder quando era criança?', p: 'all', th: 'infancia', tone: 'leve', sens: 0 },
    { t: 'Qual era a guloseima que mais lhe apetecia em miúdo?', p: 'all', th: 'infancia', tone: 'leve', sens: 0 },
    { t: 'Que som da sua infância ainda hoje reconhece?', p: 'all', th: 'infancia', tone: 'emocional', sens: 0 },
    { t: 'Quem tomava conta de si quando era pequeno?', p: 'all', th: 'infancia', tone: 'emocional', sens: 1 },
    { t: 'Qual foi a maior travessura que fez em criança?', p: 'all', th: 'infancia', tone: 'leve', sens: 0 },
    { t: 'Como se festejavam os aniversários lá em casa?', p: 'all', th: 'infancia', tone: 'leve', sens: 0 },
    { t: 'Que histórias lhe contavam antes de adormecer?', p: 'all', th: 'infancia', tone: 'emocional', sens: 0 },
    { t: 'Havia algum animal em casa? Como se chamava?', p: 'all', th: 'infancia', tone: 'leve', sens: 0 },
    { t: 'De que é que tinha medo quando era pequeno?', p: 'all', th: 'infancia', tone: 'emocional', sens: 1 },
    { t: 'Qual é a recordação mais feliz da sua infância?', p: 'all', th: 'infancia', tone: 'emocional', sens: 1 },
    { t: 'A que jogos brincavam na rua ou no recreio?', p: 'all', th: 'infancia', tone: 'leve', sens: 0 },
    { t: 'Como era a rua ou o bairro onde cresceu?', p: 'all', th: 'infancia', tone: 'emocional', sens: 0 },
    { t: 'Havia um lugar que, para si, era mágico em criança?', p: 'all', th: 'infancia', tone: 'emocional', sens: 0 },
    { t: 'O que é que mudaria por completo entre a infância que teve e a de hoje?', p: 'all', th: 'infancia', tone: 'profundo', sens: 1 },

    /* ───────────────────────── FAMÍLIA ───────────────────────── */
    { t: 'Quem era a pessoa mais divertida da família?', p: 'all', th: 'familia', tone: 'leve', sens: 0 },
    { t: 'Que tradição de família gostava mais de viver?', p: 'all', th: 'familia', tone: 'emocional', sens: 0 },
    { t: 'Há alguma história de família que se conta vezes sem conta?', p: 'all', th: 'familia', tone: 'leve', sens: 0 },
    { t: 'Como eram os almoços de família quando era mais novo?', p: 'all', th: 'familia', tone: 'emocional', sens: 0 },
    { t: 'Quem, na família, mais o marcou enquanto crescia?', p: 'all', th: 'familia', tone: 'emocional', sens: 1 },
    { t: 'Que objeto passou de geração em geração na sua família?', p: 'all', th: 'familia', tone: 'emocional', sens: 1 },
    { t: 'Havia algum familiar de quem toda a gente falava?', p: 'all', th: 'familia', tone: 'leve', sens: 0 },
    { t: 'O que aprendeu com os seus avós?', p: 'all', th: 'familia', tone: 'emocional', sens: 1 },
    { t: 'Como era a casa onde passou mais tempo em pequeno?', p: 'all', th: 'familia', tone: 'emocional', sens: 0 },
    { t: 'Que festas ou celebrações reuniam toda a família?', p: 'all', th: 'familia', tone: 'leve', sens: 0 },
    { t: 'Há alguém de quem sente muitas saudades?', p: 'all', th: 'familia', tone: 'profundo', sens: 2 },
    { t: 'Que parecenças vê entre si e as pessoas que o criaram?', p: 'all', th: 'familia', tone: 'emocional', sens: 1 },
    { t: 'Como foi tornar-se pai ou mãe pela primeira vez?', p: 'par', th: 'familia', tone: 'emocional', sens: 1,
      alt: { pai: 'Como foi tornar-se pai pela primeira vez?', mae: 'Como foi tornar-se mãe pela primeira vez?', pais: 'Como foi tornarem-se pais pela primeira vez?' } },
    { t: 'Do que se lembra da primeira vez que pegou num neto ao colo?', p: 'gp', th: 'familia', tone: 'emocional', sens: 1 },
    { t: 'Que nome de família tem uma história curiosa por trás?', p: 'all', th: 'familia', tone: 'leve', sens: 0 },
    { t: 'O que gostaria que os seus netos soubessem sobre si?', p: 'gp', th: 'familia', tone: 'emocional', sens: 1 },
    { t: 'Que memória guarda dos seus irmãos, se os teve?', p: 'all', th: 'familia', tone: 'emocional', sens: 1 },
    { t: 'Qual é a pessoa da família a quem sente que se parece mais no feitio?', p: 'all', th: 'familia', tone: 'emocional', sens: 0 },

    /* ───────────────────── ESCOLA E JUVENTUDE ───────────────────── */
    { t: 'Como era a sua escola quando era jovem?', p: 'all', th: 'escola', tone: 'leve', sens: 0 },
    { t: 'Qual era a disciplina de que mais gostava?', p: 'all', th: 'escola', tone: 'leve', sens: 0 },
    { t: 'Houve algum professor de quem nunca se esqueceu?', p: 'all', th: 'escola', tone: 'emocional', sens: 0 },
    { t: 'Como era um sábado à noite quando tinha vinte anos?', p: 'all', th: 'escola', tone: 'leve', sens: 0 },
    { t: 'Que música o transporta imediatamente para a sua juventude?', p: 'all', th: 'escola', tone: 'emocional', sens: 0 },
    { t: 'Como se vestia e arranjava quando saía com os amigos?', p: 'all', th: 'escola', tone: 'leve', sens: 0 },
    { t: 'Quem era o seu melhor amigo nessa altura?', p: 'all', th: 'escola', tone: 'emocional', sens: 1 },
    { t: 'Que loucura da juventude ainda hoje lhe arranca um sorriso?', p: 'all', th: 'escola', tone: 'leve', sens: 0 },
    { t: 'Até onde estudou e como foi essa decisão?', p: 'all', th: 'escola', tone: 'emocional', sens: 1 },
    { t: 'Como era divertir-se no seu tempo, sem telemóveis?', p: 'all', th: 'escola', tone: 'leve', sens: 0 },
    { t: 'Qual foi o primeiro concerto, baile ou festa de que se lembra?', p: 'all', th: 'escola', tone: 'leve', sens: 0 },
    { t: 'O que sonhava ser quando fosse grande?', p: 'all', th: 'escola', tone: 'emocional', sens: 0 },
    { t: 'Houve alguma regra em casa, na juventude, que achava injusta?', p: 'all', th: 'escola', tone: 'leve', sens: 0 },
    { t: 'De que é que sente mais saudades desse tempo de juventude?', p: 'all', th: 'escola', tone: 'emocional', sens: 1 },
    { t: 'Se pudesse dar um conselho ao jovem que foi, qual seria?', p: 'all', th: 'escola', tone: 'profundo', sens: 1 },

    /* ───────────────────────── TRABALHO ───────────────────────── */
    { t: 'Qual foi o seu primeiro trabalho?', p: 'all', th: 'trabalho', tone: 'leve', sens: 0 },
    { t: 'Como era um dia de trabalho no seu tempo?', p: 'all', th: 'trabalho', tone: 'leve', sens: 0 },
    { t: 'O que fazia para ganhar a vida e gostava do que fazia?', p: 'all', th: 'trabalho', tone: 'emocional', sens: 1 },
    { t: 'Qual foi o trabalho mais difícil que teve?', p: 'all', th: 'trabalho', tone: 'emocional', sens: 1 },
    { t: 'Quem lhe ensinou a fazer o seu ofício?', p: 'all', th: 'trabalho', tone: 'emocional', sens: 0 },
    { t: 'Do que é que mais se orgulha em toda a sua vida de trabalho?', p: 'all', th: 'trabalho', tone: 'emocional', sens: 1 },
    { t: 'Recorda-se do seu primeiro ordenado e do que fez com ele?', p: 'all', th: 'trabalho', tone: 'leve', sens: 0 },
    { t: 'Houve alguma decisão profissional que mudou o seu caminho?', p: 'all', th: 'trabalho', tone: 'profundo', sens: 1 },
    { t: 'Como conciliava o trabalho com a família?', p: 'desc', th: 'trabalho', tone: 'emocional', sens: 1 },
    { t: 'Que colega ou patrão nunca mais esqueceu?', p: 'all', th: 'trabalho', tone: 'emocional', sens: 0 },
    { t: 'Se pudesse ter seguido outra profissão, qual teria sido?', p: 'all', th: 'trabalho', tone: 'profundo', sens: 1 },
    { t: 'Como era o dinheiro e a vida no seu tempo, comparado com hoje?', p: 'all', th: 'trabalho', tone: 'leve', sens: 0 },
    { t: 'O que aprendeu a fazer com as mãos que hoje quase ninguém sabe?', p: 'all', th: 'trabalho', tone: 'emocional', sens: 0 },
    { t: 'Como foi o dia em que se reformou, se já aconteceu?', p: 'all', th: 'trabalho', tone: 'emocional', sens: 1 },
    { t: 'Que lição do trabalho gostaria de deixar às gerações mais novas?', p: 'all', th: 'trabalho', tone: 'profundo', sens: 1 },

    /* ─────────────────────── AMOR E RELAÇÕES ─────────────────────── */
    { t: 'Lembra-se do seu primeiro grande amor?', p: 'all', th: 'amor', tone: 'emocional', sens: 1 },
    { t: 'Como era namorar no seu tempo?', p: 'all', th: 'amor', tone: 'leve', sens: 0 },
    { t: 'O que é, para si, o mais importante numa relação?', p: 'all', th: 'amor', tone: 'profundo', sens: 1 },
    { t: 'Qual foi o gesto mais bonito que alguém teve por si?', p: 'all', th: 'amor', tone: 'emocional', sens: 1 },
    { t: 'Como se conquistava alguém antigamente?', p: 'all', th: 'amor', tone: 'leve', sens: 0 },
    { t: 'O que aprendeu sobre o amor ao longo da vida?', p: 'all', th: 'amor', tone: 'profundo', sens: 1 },
    { t: 'Houve um lugar especial que marcou uma história de amor sua?', p: 'all', th: 'amor', tone: 'emocional', sens: 1 },
    { t: 'Qual é o segredo, se existe, para gostar de alguém muitos anos?', p: 'all', th: 'amor', tone: 'profundo', sens: 1 },
    { t: 'Que canção lhe faz lembrar uma pessoa de quem gostou muito?', p: 'all', th: 'amor', tone: 'emocional', sens: 1 },
    { t: 'Como demonstravam o carinho lá em casa quando era novo?', p: 'all', th: 'amor', tone: 'emocional', sens: 1 },
    { t: 'Alguma vez o coração o levou a fazer uma loucura bonita?', p: 'all', th: 'amor', tone: 'leve', sens: 0 },
    { t: 'O que gostaria que soubéssemos sobre as pessoas que amou?', p: 'all', th: 'amor', tone: 'profundo', sens: 2 },
    { t: 'Que amizade da sua vida foi tão forte como uma família?', p: 'all', th: 'amor', tone: 'emocional', sens: 1 },
    { t: 'Como é, para si, cuidar de quem se ama?', p: 'all', th: 'amor', tone: 'profundo', sens: 1 },
    { t: 'Há alguma carta ou recado que guardou de alguém especial?', p: 'all', th: 'amor', tone: 'emocional', sens: 1 },

    /* ─────────────────── RECEITAS E TRADIÇÕES ─────────────────── */
    { t: 'Quem lhe ensinou uma receita que ainda hoje guarda?', p: 'all', th: 'receitas', tone: 'emocional', sens: 0 },
    { t: 'Qual é o prato que lhe sabe sempre a casa?', p: 'all', th: 'receitas', tone: 'emocional', sens: 0 },
    { t: 'Que receita gostaria que ninguém deixasse cair no esquecimento?', p: 'all', th: 'receitas', tone: 'emocional', sens: 1 },
    { t: 'Como era o Natal lá em casa quando era pequeno?', p: 'all', th: 'receitas', tone: 'emocional', sens: 0 },
    { t: 'Qual era o doce que só aparecia em dias de festa?', p: 'all', th: 'receitas', tone: 'leve', sens: 0 },
    { t: 'Há algum truque de cozinha que passa de geração em geração?', p: 'all', th: 'receitas', tone: 'leve', sens: 0 },
    { t: 'Que cheiros vinham da cozinha da sua mãe ou da sua avó?', p: 'all', th: 'receitas', tone: 'emocional', sens: 1 },
    { t: 'Qual é a tradição de família que faz questão de manter?', p: 'all', th: 'receitas', tone: 'emocional', sens: 0 },
    { t: 'Como se punha a mesa nos dias importantes?', p: 'all', th: 'receitas', tone: 'leve', sens: 0 },
    { t: 'Havia algum ritual à volta da comida que adorava?', p: 'all', th: 'receitas', tone: 'emocional', sens: 0 },
    { t: 'Que festa popular ou romaria marcava o seu ano?', p: 'all', th: 'receitas', tone: 'leve', sens: 0 },
    { t: 'Qual é o ingrediente que não pode faltar na sua cozinha?', p: 'all', th: 'receitas', tone: 'leve', sens: 0 },
    { t: 'Que prato aprendeu a fazer só a olhar para quem cozinhava?', p: 'all', th: 'receitas', tone: 'emocional', sens: 0 },
    { t: 'Há alguma tradição que se perdeu e de que tem pena?', p: 'all', th: 'receitas', tone: 'profundo', sens: 1 },
    { t: 'Se pudesse cozinhar uma refeição para toda a família, qual seria?', p: 'all', th: 'receitas', tone: 'emocional', sens: 0 },
    { t: 'Que sabor da sua terra não encontra em mais lado nenhum?', p: 'all', th: 'receitas', tone: 'emocional', sens: 0 },

    /* ─────────────────── EMIGRAÇÃO E VIAGENS ─────────────────── */
    { t: 'Qual foi a viagem que mais o marcou?', p: 'all', th: 'emigracao', tone: 'emocional', sens: 0 },
    { t: 'Alguma vez teve de deixar a sua terra? Como foi?', p: 'all', th: 'emigracao', tone: 'profundo', sens: 2 },
    { t: 'Que lugar sempre sonhou conhecer?', p: 'all', th: 'emigracao', tone: 'leve', sens: 0 },
    { t: 'Como era a terra onde nasceu?', p: 'all', th: 'emigracao', tone: 'emocional', sens: 0 },
    { t: 'Há algum sítio a que gosta sempre de voltar?', p: 'all', th: 'emigracao', tone: 'emocional', sens: 0 },
    { t: 'Se viveu longe de casa, do que sentia mais falta?', p: 'all', th: 'emigracao', tone: 'profundo', sens: 2 },
    { t: 'Que paisagem lhe ficou para sempre na memória?', p: 'all', th: 'emigracao', tone: 'emocional', sens: 0 },
    { t: 'Como se mantinha o contacto com a família quando se estava longe?', p: 'all', th: 'emigracao', tone: 'emocional', sens: 1 },
    { t: 'Qual foi a maior aventura da sua vida?', p: 'all', th: 'emigracao', tone: 'leve', sens: 0 },
    { t: 'Que línguas ou sotaques diferentes conheceu ao longo da vida?', p: 'all', th: 'emigracao', tone: 'leve', sens: 0 },
    { t: 'Há uma terra que sente como sua, mesmo não tendo nascido lá?', p: 'all', th: 'emigracao', tone: 'emocional', sens: 1 },
    { t: 'Como era viajar no seu tempo, comparado com hoje?', p: 'all', th: 'emigracao', tone: 'leve', sens: 0 },
    { t: 'O que traria numa mala se tivesse de recomeçar noutro sítio?', p: 'all', th: 'emigracao', tone: 'profundo', sens: 1 },
    { t: 'Que história de uma viagem gosta sempre de contar?', p: 'all', th: 'emigracao', tone: 'leve', sens: 0 },

    /* ───────────── DESAFIOS E MOMENTOS DIFÍCEIS ───────────── */
    { t: 'De onde tirou força nos momentos mais difíceis?', p: 'all', th: 'desafios', tone: 'profundo', sens: 2 },
    { t: 'Qual foi o maior desafio que teve de enfrentar?', p: 'all', th: 'desafios', tone: 'profundo', sens: 2 },
    { t: 'O que o ajudou a seguir em frente quando tudo parecia difícil?', p: 'all', th: 'desafios', tone: 'profundo', sens: 2 },
    { t: 'Que época da sua vida foi mais exigente e o que aprendeu com ela?', p: 'all', th: 'desafios', tone: 'profundo', sens: 2 },
    { t: 'Houve um momento em que teve de ser corajoso sem escolha?', p: 'all', th: 'desafios', tone: 'profundo', sens: 2 },
    { t: 'Que preocupação carregou durante muito tempo e como a resolveu?', p: 'all', th: 'desafios', tone: 'profundo', sens: 2 },
    { t: 'Quem esteve ao seu lado quando mais precisou?', p: 'all', th: 'desafios', tone: 'emocional', sens: 1 },
    { t: 'O que faz para recuperar o ânimo em dias menos bons?', p: 'all', th: 'desafios', tone: 'emocional', sens: 1 },
    { t: 'Que mudança na sua vida foi difícil mas acabou por ser boa?', p: 'all', th: 'desafios', tone: 'profundo', sens: 1 },
    { t: 'Há alguma coisa de que teve medo e que hoje já não o assusta?', p: 'all', th: 'desafios', tone: 'profundo', sens: 1 },
    { t: 'O que aprendeu sobre si próprio nos tempos mais duros?', p: 'all', th: 'desafios', tone: 'profundo', sens: 2 },
    { t: 'Como mudou a sua maneira de ver a vida com os anos?', p: 'all', th: 'desafios', tone: 'profundo', sens: 1 },
    { t: 'Que perda lhe ensinou a dar valor ao que é simples?', p: 'all', th: 'desafios', tone: 'profundo', sens: 2 },
    { t: 'Se pudesse tranquilizar o você de há trinta anos, o que lhe diria?', p: 'all', th: 'desafios', tone: 'profundo', sens: 1 },

    /* ─────────────────── SONHOS E ESCOLHAS ─────────────────── */
    { t: 'Que sonho realizou de que mais se orgulha?', p: 'all', th: 'sonhos', tone: 'emocional', sens: 1 },
    { t: 'Há algum sonho que ainda gostava de concretizar?', p: 'all', th: 'sonhos', tone: 'emocional', sens: 1 },
    { t: 'Que decisão mudou mais a sua vida?', p: 'all', th: 'sonhos', tone: 'profundo', sens: 1 },
    { t: 'Do que é que mais se orgulha em tudo o que já viveu?', p: 'all', th: 'sonhos', tone: 'emocional', sens: 1 },
    { t: 'Se pudesse voltar atrás, mudaria alguma escolha?', p: 'all', th: 'sonhos', tone: 'profundo', sens: 2 },
    { t: 'O que gostaria de ter tido coragem de fazer mais cedo?', p: 'all', th: 'sonhos', tone: 'profundo', sens: 1 },
    { t: 'Qual foi o melhor risco que alguma vez correu?', p: 'all', th: 'sonhos', tone: 'emocional', sens: 1 },
    { t: 'O que o faz sentir verdadeiramente realizado?', p: 'all', th: 'sonhos', tone: 'profundo', sens: 1 },
    { t: 'Que projeto ou ideia lhe deu mais alegria pôr de pé?', p: 'all', th: 'sonhos', tone: 'emocional', sens: 0 },
    { t: 'Qual foi a escolha mais corajosa que fez na vida?', p: 'all', th: 'sonhos', tone: 'profundo', sens: 1 },
    { t: 'Se o dinheiro não contasse, como passaria os seus dias?', p: 'all', th: 'sonhos', tone: 'leve', sens: 0 },
    { t: 'Que pequeno prazer da vida nunca deixaria de ter?', p: 'all', th: 'sonhos', tone: 'leve', sens: 0 },
    { t: 'O que descobriu tarde e gostava de ter sabido mais cedo?', p: 'all', th: 'sonhos', tone: 'profundo', sens: 1 },
    { t: 'Que lugar do mundo ainda gostava de ver com os seus olhos?', p: 'all', th: 'sonhos', tone: 'leve', sens: 0 },
    { t: 'O que é, para si, uma vida bem vivida?', p: 'all', th: 'sonhos', tone: 'profundo', sens: 1 },

    /* ─────────────────── VALORES E CONSELHOS ─────────────────── */
    { t: 'Que conselho gostaria de deixar às gerações seguintes?', p: 'all', th: 'valores', tone: 'profundo', sens: 1 },
    { t: 'Qual é o valor que considera mais importante na vida?', p: 'all', th: 'valores', tone: 'profundo', sens: 1 },
    { t: 'O que aprendeu que gostaria que nunca se perdesse na família?', p: 'all', th: 'valores', tone: 'emocional', sens: 1 },
    { t: 'Que ditado ou frase usava muito lá em casa?', p: 'all', th: 'valores', tone: 'leve', sens: 0 },
    { t: 'O que é, para si, ser uma boa pessoa?', p: 'all', th: 'valores', tone: 'profundo', sens: 1 },
    { t: 'Que erro seu se tornou a sua melhor lição?', p: 'all', th: 'valores', tone: 'profundo', sens: 1 },
    { t: 'O que aprendeu com quem o criou e ainda hoje segue?', p: 'all', th: 'valores', tone: 'emocional', sens: 1 },
    { t: 'Que qualidade admira mais nas pessoas?', p: 'all', th: 'valores', tone: 'emocional', sens: 0 },
    { t: 'O que mudou na sociedade que acha que se perdeu?', p: 'all', th: 'valores', tone: 'profundo', sens: 1 },
    { t: 'Que hábito simples fez sempre a diferença na sua vida?', p: 'all', th: 'valores', tone: 'emocional', sens: 0 },
    { t: 'Como aprendeu a lidar com quem pensa de forma diferente?', p: 'all', th: 'valores', tone: 'profundo', sens: 1 },
    { t: 'O que gostaria que os mais novos percebessem cedo na vida?', p: 'all', th: 'valores', tone: 'profundo', sens: 1 },
    { t: 'Que promessa fez a si próprio e cumpriu?', p: 'all', th: 'valores', tone: 'profundo', sens: 1 },
    { t: 'O que o faz sentir orgulho quando olha para a sua família?', p: 'desc', th: 'valores', tone: 'emocional', sens: 1 },
    { t: 'Se tivesse de resumir a vida numa frase, qual seria?', p: 'all', th: 'valores', tone: 'profundo', sens: 1 },
    { t: 'Que gesto de bondade nunca esqueceu?', p: 'all', th: 'valores', tone: 'emocional', sens: 1 },

    /* ─────────────────── LEGADO E FUTURO ─────────────────── */
    { t: 'Como gostaria de ser recordado?', p: 'all', th: 'legado', tone: 'profundo', sens: 2 },
    { t: 'Que história sua gostaria que passasse aos seus netos?', p: 'gp', th: 'legado', tone: 'emocional', sens: 1 },
    { t: 'O que gostaria que a sua família nunca esquecesse?', p: 'desc', th: 'legado', tone: 'emocional', sens: 1 },
    { t: 'Que herança, que não seja dinheiro, gostava de deixar?', p: 'all', th: 'legado', tone: 'profundo', sens: 1 },
    { t: 'O que espera para as gerações que vêm a seguir?', p: 'all', th: 'legado', tone: 'emocional', sens: 1 },
    { t: 'Que objeto seu gostava que ficasse na família para sempre?', p: 'all', th: 'legado', tone: 'emocional', sens: 1 },
    { t: 'Se pudesse deixar uma mensagem para daqui a cinquenta anos, qual seria?', p: 'all', th: 'legado', tone: 'profundo', sens: 1 },
    { t: 'Que parte da sua história acha que ainda ninguém conhece bem?', p: 'all', th: 'legado', tone: 'profundo', sens: 1 },
    { t: 'O que gostava que dissessem de si daqui a muitos anos?', p: 'all', th: 'legado', tone: 'profundo', sens: 2 },
    { t: 'Que ensinamento gostaria de deixar aos seus filhos?', p: 'par', th: 'legado', tone: 'emocional', sens: 1 },
    { t: 'De tudo o que viveu, o que mais gostaria de guardar em livro?', p: 'all', th: 'legado', tone: 'emocional', sens: 1 },
    { t: 'Que momento da sua vida merecia uma fotografia na parede?', p: 'all', th: 'legado', tone: 'emocional', sens: 0 },
    { t: 'O que aprendeu com a vida que só o tempo lhe pôde ensinar?', p: 'all', th: 'legado', tone: 'profundo', sens: 1 },
    { t: 'Que tradição gostaria que a família continuasse a fazer sem si?', p: 'all', th: 'legado', tone: 'profundo', sens: 2 },
    { t: 'Se ouvisse a sua própria voz daqui a muitos anos, o que gostaria de ter dito?', p: 'all', th: 'legado', tone: 'profundo', sens: 1 },
    { t: 'O que é, para si, deixar uma marca no mundo?', p: 'all', th: 'legado', tone: 'profundo', sens: 1 },

    /* ─────────────────────── COMPLEMENTOS ─────────────────────── */
    { t: 'Qual era o programa de televisão ou de rádio que não perdia?', p: 'all', th: 'escola', tone: 'leve', sens: 0 },
    { t: 'Que moda da sua juventude acha que devia voltar?', p: 'all', th: 'escola', tone: 'leve', sens: 0 },
    { t: 'Qual era a sua alcunha em novo, se teve alguma?', p: 'all', th: 'infancia', tone: 'leve', sens: 0 },
    { t: 'Que aparelho ou máquina o deixou maravilhado quando apareceu?', p: 'all', th: 'trabalho', tone: 'leve', sens: 0 },
    { t: 'Que habilidade tem que quase ninguém conhece?', p: 'all', th: 'trabalho', tone: 'leve', sens: 0 },
    { t: 'Qual é a primeira coisa que faz de manhã, sem falta?', p: 'all', th: 'valores', tone: 'leve', sens: 0 },
    { t: 'Que encontro inesperado mudou o rumo do seu dia ou da sua vida?', p: 'all', th: 'amor', tone: 'emocional', sens: 1 },
    { t: 'Que festa ou romaria da sua terra nunca falhava?', p: 'all', th: 'emigracao', tone: 'leve', sens: 0 },
    { t: 'Que mercado, feira ou loja adorava visitar em novo?', p: 'all', th: 'emigracao', tone: 'leve', sens: 0 },
    { t: 'O que faz sempre um dia difícil parecer mais leve?', p: 'all', th: 'desafios', tone: 'emocional', sens: 1 },
    { t: 'Que pequeno hábito o ajuda a manter a calma?', p: 'all', th: 'desafios', tone: 'emocional', sens: 1 },
    { t: 'Se ganhasse um dia inteiro só para si, como o passaria?', p: 'all', th: 'sonhos', tone: 'leve', sens: 0 },
    { t: 'Que talento gostaria de ter tido tempo para desenvolver?', p: 'all', th: 'sonhos', tone: 'emocional', sens: 1 },
    { t: 'Qual é o cheiro ou sabor que lhe traz logo boas memórias?', p: 'all', th: 'receitas', tone: 'emocional', sens: 0 },
    { t: 'Que momento simples do dia a dia mais valoriza hoje?', p: 'all', th: 'valores', tone: 'emocional', sens: 0 },
    { t: 'O que gostaria de ensinar, com calma, a um neto ou a uma criança?', p: 'desc', th: 'legado', tone: 'emocional', sens: 1 }
  ];

  /* ─────────────────────── configuração ─────────────────────── */
  var PSET = {
    all:  ['pai', 'mae', 'avo', 'ava', 'outro'],
    gp:   ['avo', 'ava'],
    par:  ['pai', 'mae'],
    desc: ['pai', 'mae', 'avo', 'ava']
  };

  var PERSON_LABEL = {
    pai: 'o seu pai', mae: 'a sua mãe', avo: 'o seu avô', ava: 'a sua avó',
    pais: 'os seus pais', avos: 'os seus avós', outro: 'o seu familiar'
  };

  var THEME_LABEL = {
    infancia: 'Infância', familia: 'Família', escola: 'Escola e juventude',
    trabalho: 'Trabalho', amor: 'Amor e relações', receitas: 'Receitas e tradições',
    emigracao: 'Emigração e viagens', desafios: 'Desafios e momentos difíceis',
    sonhos: 'Sonhos e escolhas', valores: 'Valores e conselhos', legado: 'Legado e futuro'
  };

  var ALL_THEMES = Object.keys(THEME_LABEL);

  // Estilo -> tons permitidos + teto de sensibilidade
  var STYLE = {
    leve:      { tones: ['leve'], maxSens: 0 },
    emocional: { tones: ['emocional'], maxSens: 1 },
    profundo:  { tones: ['profundo'], maxSens: 2 },
    misturado: { tones: ['leve', 'emocional', 'profundo'], maxSens: 2 }
  };
  // Fallback de tom quando um estilo produz poucas perguntas (mantém sempre o teto de sensibilidade)
  var STYLE_FALLBACK = {
    leve: ['leve', 'emocional'],
    emocional: ['emocional', 'leve', 'profundo'],
    profundo: ['profundo', 'emocional'],
    misturado: ['leve', 'emocional', 'profundo']
  };

  /* ─────────────────────── utilitários ─────────────────────── */

  // Baralhar Fisher-Yates (sem estado persistente)
  function shuffle(arr) {
    var a = arr.slice(), i, j, tmp;
    for (i = a.length - 1; i > 0; i--) {
      j = Math.floor(Math.random() * (i + 1));
      tmp = a[i]; a[i] = a[j]; a[j] = tmp;
    }
    return a;
  }

  function compat(q, person) {
    var set = PSET[q.p] || [q.p];
    if (person === 'pais') return set.indexOf('pai') >= 0 || set.indexOf('mae') >= 0;
    if (person === 'avos') return set.indexOf('avo') >= 0 || set.indexOf('ava') >= 0;
    return set.indexOf(person) >= 0;
  }

  function textFor(q, person) {
    if (q.alt) {
      if (q.alt[person]) return q.alt[person];
      if ((person === 'pais') && q.alt.par) return q.alt.par;
      if ((person === 'avos') && q.alt.gp) return q.alt.gp;
    }
    return q.t;
  }

  // Índice estável para cada pergunta (para histórico de sessão)
  BANK.forEach(function (q, i) { q._id = i; });

  /* ─────────────────────── motor de geração ─────────────────────── */
  // history: Set de _id mostrados na sessão (só em memória)
  var recent = [];

  function pool(person, themes, tones, maxSens) {
    var wantAllThemes = !themes || themes.length === 0 || themes.indexOf('mistura') >= 0;
    return BANK.filter(function (q) {
      if (!compat(q, person)) return false;
      if (!wantAllThemes && themes.indexOf(q.th) < 0) return false;
      if (tones.indexOf(q.tone) < 0) return false;
      if (q.sens > maxSens) return false;
      return true;
    });
  }

  // Seleção equilibrada por tema, sem duplicados, evitando repetir a lista anterior.
  function pickBalanced(candidates, themes, count) {
    var wantAllThemes = !themes || themes.length === 0 || themes.indexOf('mistura') >= 0;
    var groups = {};
    var order = wantAllThemes ? ALL_THEMES.slice() : themes.filter(function (t) { return t !== 'mistura'; });
    order.forEach(function (t) { groups[t] = []; });

    // Desprioriza perguntas mostradas há pouco (para "Gerar novamente")
    var recentSet = {};
    recent.forEach(function (id) { recentSet[id] = true; });
    var fresh = shuffle(candidates.filter(function (q) { return !recentSet[q._id]; }));
    var seen  = shuffle(candidates.filter(function (q) { return recentSet[q._id]; }));
    var ranked = fresh.concat(seen); // frescas primeiro, repetidas só se faltarem

    ranked.forEach(function (q) {
      if (groups[q.th]) groups[q.th].push(q);
      else { (groups._extra = groups._extra || []).push(q); }
    });

    var picked = [];
    var used = {};
    var themeKeys = order.slice();
    if (groups._extra) themeKeys.push('_extra');

    // Round-robin equilibrado entre temas
    var progress = true;
    while (picked.length < count && progress) {
      progress = false;
      for (var k = 0; k < themeKeys.length && picked.length < count; k++) {
        var g = groups[themeKeys[k]];
        if (!g || !g.length) continue;
        var q = g.shift();
        if (used[q._id]) continue;
        used[q._id] = true;
        picked.push(q);
        progress = true;
      }
    }
    return picked;
  }

  function generate(opts) {
    var person = opts.person;
    var themes = opts.themes || [];
    var styleKey = opts.style || 'misturado';
    var count = opts.count || 10;

    var style = STYLE[styleKey] || STYLE.misturado;
    var maxSens = style.maxSens;

    // 1) filtro primário
    var cand = pool(person, themes, style.tones, maxSens);

    // 2) fallback de tom (mantém teto de sensibilidade) se faltarem perguntas
    if (cand.length < count) {
      cand = pool(person, themes, STYLE_FALLBACK[styleKey] || style.tones, maxSens);
    }
    // 3) fallback de tema (ignora temas, mantém pessoa + tom + sensibilidade)
    var broadenedThemes = false;
    if (cand.length < count) {
      cand = pool(person, [], STYLE_FALLBACK[styleKey] || style.tones, maxSens);
      broadenedThemes = true;
    }

    var picked = pickBalanced(cand, broadenedThemes ? [] : themes, count);

    // registar no histórico de sessão
    picked.forEach(function (q) { recent.push(q._id); });
    // manter o histórico com um tamanho razoável (só memória)
    if (recent.length > 80) recent = recent.slice(recent.length - 80);

    return {
      person: person,
      themes: (themes.indexOf('mistura') >= 0 || themes.length === 0) ? ['mistura'] : themes,
      style: styleKey,
      requested: count,
      questions: picked.map(function (q) {
        return { id: q._id, text: textFor(q, person), theme: q.th, tone: q.tone };
      }),
      truncated: picked.length < count
    };
  }

  // Exposição para testes (sem efeitos colaterais de UI)
  window.MHQG = {
    BANK: BANK,
    THEME_LABEL: THEME_LABEL,
    PERSON_LABEL: PERSON_LABEL,
    generate: generate,
    _resetHistory: function () { recent = []; }
  };

  /* ─────────────────────── analytics (opcional) ─────────────────────── */
  function track(evt, params) {
    try {
      if (window.dataLayer && typeof window.dataLayer.push === 'function') {
        var payload = { event: evt };
        if (params) { for (var k in params) { if (params.hasOwnProperty(k)) payload[k] = params[k]; } }
        window.dataLayer.push(payload); // nunca inclui as perguntas nem texto do utilizador
      }
    } catch (e) { /* silencioso */ }
  }

  /* ─────────────────────── UI ─────────────────────── */
  function byId(id) { return document.getElementById(id); }

  function selectedThemes(root) {
    var boxes = root.querySelectorAll('input[name="mhqg-theme"]:checked');
    var arr = [];
    for (var i = 0; i < boxes.length; i++) arr.push(boxes[i].value);
    return arr;
  }

  function announce(root, msg) {
    var live = root.querySelector('[data-mhqg-status]');
    if (live) live.textContent = msg;
  }

  function buildList(result) {
    return result.questions.map(function (q, i) { return (i + 1) + '. ' + q.text; }).join('\n');
  }

  function themesText(result) {
    if (result.themes.indexOf('mistura') >= 0) return 'Mistura de temas';
    return result.themes.map(function (t) { return THEME_LABEL[t] || t; }).join(', ');
  }

  function init(root) {
    if (!root || root.getAttribute('data-mhqg-ready') === '1') return;
    root.setAttribute('data-mhqg-ready', '1');

    var form = root.querySelector('[data-mhqg-form]');
    var resultsWrap = root.querySelector('[data-mhqg-results]');
    var listEl = root.querySelector('[data-mhqg-list]');
    var metaEl = root.querySelector('[data-mhqg-meta]');
    var lastResult = null;
    root.mh61GetQuestions = function(){ return lastResult; };

    track('mh_question_generator_view');

    function currentOpts() {
      var personEl = root.querySelector('input[name="mhqg-person"]:checked');
      var styleEl = root.querySelector('input[name="mhqg-style"]:checked');
      var countEl = root.querySelector('input[name="mhqg-count"]:checked');
      return {
        person: personEl ? personEl.value : 'avos',
        themes: selectedThemes(root),
        style: styleEl ? styleEl.value : 'misturado',
        count: countEl ? parseInt(countEl.value, 10) : 10,
        personName: (root.querySelector('[data-mhqg-name]') || {}).value || ''
      };
    }

    function render(result) {
      lastResult = result;
      // meta
      var themeCount = result.themes.indexOf('mistura') >= 0 ? ALL_THEMES.length : result.themes.length;
      metaEl.innerHTML = '';
      var pers = document.createElement('p');
      pers.className = 'mhqg-result-line';
      pers.innerHTML = '<strong>' + result.questions.length + '</strong> perguntas para <strong>' +
        (PERSON_LABEL[result.person] || 'a sua família') + '</strong>';
      var th = document.createElement('p');
      th.className = 'mhqg-result-line mhqg-result-line--muted';
      th.textContent = 'Temas: ' + themesText(result);
      metaEl.appendChild(pers);
      metaEl.appendChild(th);
      var guestName = ((root.querySelector('[data-mhqg-name]') || {}).value || '').trim().slice(0,60);
      if (guestName) {
        var nm = document.createElement('p');
        nm.className = 'mhqg-result-line mh61-name-line';
        nm.textContent = 'Questionário preparado para ' + guestName;
        metaEl.appendChild(nm);
      }
      if (result.truncated) {
        var warn = document.createElement('p');
        warn.className = 'mhqg-result-line mhqg-result-line--muted';
        warn.textContent = 'Com estas escolhas há menos perguntas disponíveis. Experimente mais temas ou outro estilo para obter mais.';
        metaEl.appendChild(warn);
      }
      // lista
      listEl.innerHTML = '';
      result.questions.forEach(function (q, idx) {
        var li = document.createElement('li');
        li.className = 'mh61-question';
        var contents = document.createElement('span');
        contents.className = 'mh61-question-text';
        contents.textContent = q.text;
        var tools = document.createElement('span');
        tools.className = 'mh61-question-tools';
        var edit = document.createElement('button');
        edit.type = 'button'; edit.textContent = 'Editar';
        edit.setAttribute('aria-label','Editar a pergunta '+(idx+1));
        edit.addEventListener('click',function(){
          if (edit.dataset.editing==='1') return;
          if (li.querySelector('textarea')) return;
          edit.dataset.editing='1';
          var input=document.createElement('textarea'); input.className='mh61-question-input';
          input.maxLength=300; input.value=q.text; input.rows=3;
          input.setAttribute('aria-label','Texto da pergunta '+(idx+1));
          contents.replaceWith(input); input.focus();
          edit.textContent='Guardar';
          edit.onclick=function(){
            var v=input.value.trim();
            if (!v){ announce(root,'A pergunta não pode ficar vazia.');return; }
            q.text=v; contents.textContent=v; input.replaceWith(contents); edit.textContent='Editar'; edit.dataset.editing='0';
            edit.onclick=null;track('mh_question_generator_edit');announce(root,'Pergunta atualizada.');
          };
        });
        var renew=document.createElement('button');
        renew.type='button';renew.textContent='Trocar';
        renew.setAttribute('aria-label','Substituir a pergunta '+(idx+1));
        renew.addEventListener('click',function(){
          var choices=generate(currentOpts()).questions;
          var other=choices.find(function(item){
            return item.text!==q.text && !result.questions.some(function(existing){return existing.text===item.text;});
          });
          if(!other){announce(root,'Experimente outro tema para ter mais perguntas.');return;}
          q.text=other.text;q.id=other.id;contents.textContent=q.text;
          track('mh_question_generator_replace'); announce(root,'Pergunta substituída.');
        });
        tools.appendChild(edit); tools.appendChild(renew);
        li.appendChild(contents); li.appendChild(tools);
        listEl.appendChild(li);
      });
      resultsWrap.hidden = false;
      announce(root, result.questions.length + ' perguntas geradas para ' + (PERSON_LABEL[result.person] || 'a sua família') + '.');
      // foco no cabeçalho dos resultados (sem scroll brusco)
      var head = root.querySelector('[data-mhqg-results-head]');
      if (head && typeof head.focus === 'function') head.focus();
      track('mh_question_generator_generate', {
        person_type: result.person, theme_count: themeCount,
        question_count: result.questions.length, tone: result.style
      });
    }

    // Gerar
    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        render(generate(currentOpts()));
      });
    }

    // Gerar novamente
    var again = root.querySelector('[data-mhqg-again]');
    if (again) again.addEventListener('click', function () {
      render(generate(currentOpts()));
      track('mh_question_generator_regenerate');
    });

    // Alterar escolhas
    var change = root.querySelector('[data-mhqg-change]');
    if (change) change.addEventListener('click', function () {
      resultsWrap.hidden = true;
      var top = root.querySelector('[data-mhqg-form-head]');
      if (top && typeof top.focus === 'function') top.focus();
    });

    // Copiar
    var copyBtn = root.querySelector('[data-mhqg-copy]');
    if (copyBtn) copyBtn.addEventListener('click', function () {
      if (!lastResult) return;
      var text = buildList(lastResult);
      var done = function () { announce(root, 'Perguntas copiadas para a área de transferência.'); flash(copyBtn, 'Copiado!'); track('mh_question_generator_copy'); };
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(text).then(done, function () { legacyCopy(text, done); });
      } else { legacyCopy(text, done); }
    });

    function legacyCopy(text, done) {
      var ta = document.createElement('textarea');
      ta.value = text; ta.setAttribute('readonly', '');
      ta.style.position = 'absolute'; ta.style.left = '-9999px';
      document.body.appendChild(ta); ta.select();
      try { document.execCommand('copy'); done(); }
      catch (e) { announce(root, 'Não foi possível copiar automaticamente. Selecione e copie a lista.'); }
      document.body.removeChild(ta);
    }

    function flash(btn, msg) {
      var original = btn.getAttribute('data-label') || btn.textContent;
      if (!btn.getAttribute('data-label')) btn.setAttribute('data-label', original);
      btn.textContent = msg;
      setTimeout(function () { btn.textContent = btn.getAttribute('data-label'); }, 1800);
    }

    // Imprimir
    var printBtn = root.querySelector('[data-mhqg-print]');
    if (printBtn) printBtn.addEventListener('click', function () {
      track('mh_question_generator_print');
      window.print();
    });

    // Partilhar
    var shareBtn = root.querySelector('[data-mhqg-share]');
    if (shareBtn) shareBtn.addEventListener('click', function () {
      if (!lastResult) return;
      var text = 'Perguntas para ' + (PERSON_LABEL[lastResult.person] || 'a família') + ':\n\n' + buildList(lastResult) +
        '\n\nGerado em ' + (window.location.origin || '') + '/pages/gerador-perguntas';
      track('mh_question_generator_share');
      if (navigator.share) {
        navigator.share({ title: 'Perguntas para pais e avós', text: text }).catch(function () { /* cancelado */ });
      } else if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(text).then(function () { announce(root, 'Lista copiada para partilhar.'); flash(shareBtn, 'Copiado!'); });
      } else {
        legacyCopy(text, function () { announce(root, 'Lista copiada para partilhar.'); });
      }
    });

    // Descarregar .txt
    var dlBtn = root.querySelector('[data-mhqg-download]');
    if (dlBtn) dlBtn.addEventListener('click', function () {
      if (!lastResult) return;
      var header = 'Perguntas para ' + (PERSON_LABEL[lastResult.person] || 'a família') +
        '\nTemas: ' + themesText(lastResult) + '\n\n';
      var content = header + buildList(lastResult) + '\n';
      var blob = new Blob([content], { type: 'text/plain;charset=utf-8' });
      var url = URL.createObjectURL(blob);
      var a = document.createElement('a');
      a.href = url; a.download = 'perguntas-para-pais-e-avos.txt';
      document.body.appendChild(a); a.click(); document.body.removeChild(a);
      setTimeout(function () { URL.revokeObjectURL(url); }, 1000);
      announce(root, 'Ficheiro de texto descarregado.');
      track('mh_question_generator_download');
    });

    // CTA comercial (analytics apenas — a modale é tratada globalmente por mh-order-modal)
    var cta = root.querySelector('[data-mhqg-cta]');
    if (cta) cta.addEventListener('click', function () { track('mh_question_generator_product_cta'); });
  }

  function boot() {
    var roots = document.querySelectorAll('[data-mhqg-root]');
    for (var i = 0; i < roots.length; i++) init(roots[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
